import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNetWorthinline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.15,
			d: "M10.5 3.75c0-.829-1.68-1.5-3.75-1.5S3.002 2.922 3 3.75c0 .829 1.678 1.5 3.75 1.5s3.75-.671 3.75-1.5M10.5 3.75v5.82M3 6.75c0 .829 1.68 1.5 3.75 1.5 2.072 0 3.75-.671 3.75-1.5M14.762 9.988a3.376 3.376 0 1 1-4.775 4.773 3.376 3.376 0 0 1 4.775-4.773"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.15,
			d: "M9.379 10.819c-.677.266-1.604.431-2.629.431-2.07 0-3.75-.671-3.75-1.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.15,
			d: "M9.334 13.833c-.673.257-1.58.417-2.584.417-2.07 0-3.75-.671-3.75-1.5v-9"
		})
	]
});
export default SvgNetWorthinline;
